import { Injectable } from '@angular/core';

export const LAST_VISIT_KEY = 'lastSiteVisit';
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const TRIAL_DURATION_MS =  ONE_DAY_MS * 10;

@Injectable({ providedIn: 'root' })
export class LastVisitService {
  constructor() {
    // visibilitychange covers most mobile & modern browsers
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.updateLastVisit();
      }
    });

    // beforeunload as a fallback for desktop
    window.addEventListener('beforeunload', () => {
      this.updateLastVisit();
    });
  }

  private updateLastVisit(): void {
    localStorage.setItem(LAST_VISIT_KEY, new Date().toISOString());
  }
}
